import React, { Component } from "react";
import {
  company,
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  Select,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  float,
  format_date,
  ActionIconButton,
  ACTION_ICONS
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission";
import { formatNumber } from "../../utils/formatting";

export default class StockAdjustment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_search: "",
      filter_status: "",

      count: 0,
      page: 1,

      // -----------------------------------
      // Modal States
      // -----------------------------------
      modal_create: false,
      modal_update: false,

      // Form States (for Create)
      uid: "",
      part_id: "",
      from_warehouse_id: "",
      adjust_type: "add",
      quantity: "",
      reason: "Stock Count Correction",
      note: "",
      
      // Update State
      status: "pending", 
      selected_item: null, // เก็บข้อมูลเดิมไว้ตอน Update

      // Master Data (สำหรับ Dropdown)
      parts_list: [],
      warehouse_list: [],

      // -----------------------------------
      // Table Data
      // -----------------------------------
      data: [],
      summary: {
        total: 0,
        pending: 0,
        completed: 0,
        cancelled: 0,
      },
    };
  }

  async componentDidMount() {
    this.Get(1);
    this.GetMasterData();
  }

  // ดึงข้อมูล Master Data สำหรับ Dropdown (Part และ Warehouse)
  GetMasterData = async () => {
    // สมมติ API ดึง Parts และ Warehouses เพื่อนำมาใช้ใน Dropdown
    // หากมี Endpoint จริงให้เปลี่ยน Path ตาม API ของคุณ
    let [res_stock] = await Promise.all([
      GET("warehouse/stocks", { page_size: 10000, page: 0 })
    ]);

    if (res_stock?.status) {
      let parts = res_stock.data?.map(e => ({ ...e, value: e.uid || e.id, label: `${e.part?.part_number} - ${e.part?.name}` }));
      this.setState({ parts_list: parts });
    }
  }

  Get = async (page) => {
    loading(true);
    const { filter_search, filter_status } = this.state;
    
    let result = await GET("warehouse/stock-movements/adjustment", {
      page: page,
      page_size: 10,
      data_search: filter_search || "",
      status: filter_status || "",
      uid: ""
    });

    if (result?.status) {
      this.setState({ 
        data: result.data || [],
        count: result.pagination?.count || 0,
        page: page,
        // Mock summary from count (ปรับ logic ตาม API จริงถ้ามีส่ง summary มา)
        summary: {
          total: result.pagination?.count || 0,
          pending: result.data?.filter(x => x.status === 'pending').length || 0,
          completed: result.data?.filter(x => x.status === 'approved').length || 0,
          cancelled: result.data?.filter(x => x.status === 'cancel').length || 0,
        }
      });
    }
    loading(false);
  }


  UpdateStatus = async (status) => {
    const { uid, selected_item, note } = this.state;

    if (await alert("", "info", t("confirm_status_change_title"), t("confirm_status_change_desc"), t("confirm"), t("cancel"))) {
      loading(true);

      // อัปเดตสถานะพร้อมความเห็น/บันทึกที่ผู้ใช้กรอกไว้ (ตรงกับ UpdateStockMovementDto ฝั่ง backend)
      let body = {
        status: status,
        notes: note || "",
      };

      // เรียก PUT โดยส่ง ID ต่อท้าย URL 
      let result = await PUT(`warehouse/stock-movements/adjustment/${uid}`, body);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.setState({ modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  }

  Delete = async (id) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      // ใช้ DELETE ยิงไปที่ endpoint ตามด้วย ID
      let result = await DELETE(`warehouse/stock-movements/adjustment/${id}`);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  }

  formatNumber = (num) => {
    return num?.toLocaleString() || "0";
  };

  getStatusLabel = (statusStr) => {
    if(statusStr === "pending") return { label: t("pending"), color: "warning" };
    if(statusStr === "completed" || statusStr === "approved") return { label: t("completed"), color: "success" };
    if(statusStr === "cancel" || statusStr === "rejected") return { label: t("cancelled"), color: "danger" };
    return { label: statusStr || "-", color: "secondary" };
  }

  render() {
    const { 
      data, count, summary, page,
      filter_search, filter_status,
       modal_update,
      parts_list, warehouse_list,
      part_id, from_warehouse_id, adjust_type, quantity, reason, note, status, selected_item
    } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarWarehouse />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1 text-dark">{t("adjustment_stocks")}</h3>
            <div className="text-secondary text-14">{t("adjustment_stocks_desc")}</div>
          </div>

          {/* Top Stats Cards */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf0cb"} {/* list */}
                  </div>
                  <div>
                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.total)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("total_adjustments")}</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf017"} {/* clock */}
                  </div>
                  <div>
                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.pending)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("pending")}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf058"} {/* check */}
                  </div>
                  <div>
                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.completed)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("completed")}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf00d"} {/* x */}
                  </div>
                  <div>
                    <h3 className="fw-bold text-danger mb-0">{this.formatNumber(summary.cancelled)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("cancelled")}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            {/* Top Filter Toolbar */}
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div className="d-flex gap-3 flex-wrap flex-grow-1">
                <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">
                    {"\uf002"}
                  </span>
                  <input
                    type="text"
                    className="form-control ps-5 wpx-300"
                    placeholder={t("search_doc_part_placeholder")}
                    value={filter_search}
                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                    // onKeyDown={(e) => e.key === 'Enter' && this.Get(1)}
                  />
                </div>
                <Select
                  className="form-control wpx-150"
                  options={[
                    { value: "pending", label: t("pending") },
                    { value: "approved", label: t("completed") },
                    { value: "cancel", label: t("cancelled") },
                  ]}
                  value={filter_status}
                  onChange={(e) => this.setState({ filter_status: e })}
                  placeholder={t("all_status")}
                  defaultLabel={t("all_status")}
                />
                <button 
                  className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" 
                  onClick={() => this.Get(1)}
                >
                  {t("filter")}
                </button>
                <button 
                  className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm" 
                  onClick={() => this.setState({ filter_search: "", filter_status: "" }, () => this.Get(1))}
                >
                  {t("clear_all")}
                </button>
              </div>
            </div>
          </div>

          {/* Main White Container */}
          <div className="bg-white rounded-4 shadow-sm pb-2">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                <thead>
                  <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                    <th className="py-3 px-4 border-0">{t("date")}</th>
                    <th className="py-3 border-0">{t("document_no")}</th>
                    <th className="py-3 border-0">{t("part_label")}</th>
                    <th className="py-3 border-0">{t("warehouse")}</th>
                    <th className="py-3 border-0 text-center">{t("quantity")}</th>
                    <th className="py-3 border-0">{t("reason")}</th>
                    <th className="py-3 border-0 text-center">{t("status")}</th>
                    <th className="py-3 border-0 text-center wpx-120">{t("manage")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center py-4 text-secondary">{t("no_data_found")}</td>
                    </tr>
                  ) : data?.map((item, idx) => {
                    let st = this.getStatusLabel(item.status);
                    return (
                    <tr key={idx} className="border-bottom border-light bg-white">
                      <td className="py-3 px-4">
                        <div className="text-dark fw-bold text-14">{item.created_at ? format_date(item.created_at, "dd-mm-yyyy hh:mm", "th") : "-"}</div>
                        <div className="text-secondary text-12">{item.doc_no || item.id}</div>
                      </td>
                      <td>
                        <div className="text-dark text-14">{item.movement_code}</div>
                      </td>
                      <td>
                        <div className="fw-bold text-primary text-14">{item.part?.part_number || "Unknown"}</div>
                        <div className="text-secondary text-12">{item.part?.name || "-"}</div>
                      </td>
                      <td>
                        <div className="text-dark text-14">{item.from_warehouse?.name || "Unknown"}</div>
                      </td>
                      <td className="text-center">
                        <span className={`fw-bold text-14 ${item.quantity > 0 ? 'text-success' : 'text-danger'}`}>
                          {item.quantity > 0 ? "+" : ""}{formatNumber(item.quantity)}
                        </span>
                      </td>
                      <td>
                        <div className="text-dark text-14">{item.reason?.name || "-"}</div>
                        <div className="text-secondary text-12 text-truncate" style={{ maxWidth: '150px' }}>{item.note}</div>
                      </td>
                      <td className="text-center">
                        <span className={`badge bg-${st.color}-light text-${st.color} rounded-pill px-3 py-1 fw-bold text-10 border border-${st.color}`}>
                          {st.label}
                        </span>
                      </td>
                      <td className="text-center">
                        {item.status === "pending" && can("stock-adjustment.update") && (
                          <div className="d-flex align-items-center gap-2 justify-content-center">
                            <ActionIconButton
                              label={t("edit_status")}
                              icon={ACTION_ICONS.edit}
                              variant="warning"
                              onClick={() => this.setState({ modal_update: true, uid: item.uid, status: item.status || "pending", selected_item: item, note: item.note || "" })}
                            />
                            {/* <span
                              className="icon pointer hover-danger transition-hover text-danger" 
                              title="Delete"
                              onClick={() => this.Delete(item.id || item.uid)}
                            >
                              {"\uf2ed"}
                            </span> */}
                          </div>
                        )}
                      </td>
                    </tr>
                  )})}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer Pagination */}
          <div className="d-flex justify-content-between align-items-center p-4 text-secondary text-12">
            <div>{t("showing")} 1-{data.length} {t("of")} {this.formatNumber(count)} {t("records")}</div>
            <Pagination
              className="mb-0"
              count={Math.ceil(count / 10) || 1}
              page={page}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, p) => this.Get(p)}
            />
          </div>
        </div>


        {/* ========================================================= */}
        {/* MODAL 2: UPDATE (เปลี่ยนได้แค่สถานะ) */}
        {/* ========================================================= */}
        <Modal
          show={modal_update}
          onHide={() => this.setState({ modal_update: false })}
          centered
          contentClassName="border-0 rounded-4 shadow-lg"
        >
           <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
            <h5 className="fw-bold mb-0 text-dark">{t("update_status_title")}</h5>
          </Modal.Header>
          <Modal.Body className="bg-white">
            <div className="mb-3">
              <label className="form-label text-14 text-secondary fw-bold mb-1">{t("reference")}</label>
              <input type="text" className="form-control bg-light" value={selected_item?.movement_code || "-"} disabled />
            </div>
            <div>
              <label className="form-label text-14 text-secondary fw-bold mb-1">{t("comment_label")} <span className="text-secondary">({t("optional")})</span></label>
              <textarea
                className="form-control shadow-none"
                rows="3"
                placeholder={t("comment_placeholder")}
                value={note}
                onChange={(e) => this.setState({ note: e.target.value })}
              ></textarea>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex gap-2">
            <button 
              className="btn btn-white border px-4 py-2 fw-bold" 
              onClick={() =>  this.setState({ modal_update: false })}
            >
              {t("cancel")}
            </button>
            <button 
              className="btn btn-danger px-4 py-2 fw-bold" 
              onClick={() => this.UpdateStatus("cancel")}
            >
              <span className="icon me-2">{"\uf00d"}</span>
              {t("reject")}
            </button>
            <button 
              className="btn btn-success px-4 py-2 fw-bold" 
              onClick={() => this.UpdateStatus("approved")}
            >
              <span className="icon me-2">{"\uf00c"}</span>
              {t("approve")}
            </button>
            </div>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}